import {AccordionItem} from 'react-light-accordion';
import Table from "../../../common/table/table";
import { ShiftReportHoursStyle } from "./shiftReportHoursStyle";
import { shiftReportSummaryTableColumns } from './shiftReportTableColumns';
import styled from 'styled-components';

const AccordionItemContainer = styled.div`
    & .accordion-item .title {
        font-size: 1.5rem;
    }

    & {
        position: sticky;
        top: 80px;
        background-color: white;
        z-index: 99999;
    }
`;

const TABLE_ROWS = [
    {
        row: 'Total Labor Count',
        accessor: 'total_count',
    },
    {
        row: 'Labor Count Over/Under (Optimal)',
        accessor: 'optimal_count',
    },
    {
        row: 'Labor Cost Impact $',
        accessor: 'cost_impact',
    },
];

const ShiftReportSummaryAccordion = ({data}) => {
    const columns = ['group_name'].concat(data.map(item => item.date));
    const tableBody = TABLE_ROWS.map((row) => {
    return columns.reduce((prevColumn, currColumn) => {
        if (currColumn !== 'group_name') {
            return ({ ...prevColumn, [currColumn]: data.filter(item => item.date === currColumn)[0][row.accessor]});
        }

        return ({ ...prevColumn, [currColumn]: row.row});

    }, {});
 });

return (
        <AccordionItemContainer>
            <AccordionItem className="card-header bg-primary" title="Company">
                <div className="p-4">
                    <ShiftReportHoursStyle>
                        <Table
                            columns={shiftReportSummaryTableColumns(columns)}
                            data={tableBody}
                            exportOptions={{pdf: false, xlsx: true, csv: true}}
                            getExportFileName={() => "shift_report_company"}
                            isSortDisabled
                        />
                    </ShiftReportHoursStyle>     
                </div>
            </AccordionItem>
        </AccordionItemContainer>
    );
}

export default ShiftReportSummaryAccordion;
